var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOntarioIconAlertSuccess = function SvgOntarioIconAlertSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#118847",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.4-1.4 3.6 3.58L17.17 7l1.4 1.42z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m5 12 5 5 8.58-8.58L17.17 7 10 14.17 6.4 10.6z"
  })));
};
export { SvgOntarioIconAlertSuccess as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSI+PHBhdGggZD0iTTEyIDJDNi40OCAyIDIgNi40OCAyIDEyczQuNDggMTAgMTAgMTAgMTAtNC40OCAxMC0xMFMxNy41MiAyIDEyIDJ6bS0yIDE1bC01LTUgMS40LTEuNCAzLjYgMy41OEwxNy4xNyA3bDEuNCAxLjQyTDEwIDE3eiIgZmlsbD0iIzExODg0NyIvPjxwYXRoIGQ9Ik01IDEybDUgNSA4LjU4LTguNThMMTcuMTcgNyAxMCAxNC4xNyA2LjQgMTAuNiA1IDEyeiIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==";